import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import { adminActionItemsQueryKey } from "../../action-item/action-item.keys";
import { bondPreviewsQueryKey } from "../../bond/bond.keys";
import { bondRequestPreviewsQueryKey } from "../bond-request.keys";
import {
	invalidateBondRequestAfterIssue,
	invalidateBondRequestIfClosed,
	redirectToIssuedBond,
} from "../utils";

export const useUploadCompletedBondForm = (id: SuretyQuoteId, accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationKey: ["uploadCompletedBondForm", id],
		mutationFn: async (data: Dtos.Admin.SuretyBondForm.Upload.Request) => {
			await post(`/v2/admin/surety/accounts/${accountId}/quotes/${id}/bond-form/upload`, data);
		},
		onSuccess: () => {
			void invalidateBondRequestAfterIssue(queryClient, id);
			queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: bondPreviewsQueryKey() });
			queryClient.invalidateQueries({ queryKey: adminActionItemsQueryKey.all() });
		},
		onSettled: invalidateBondRequestIfClosed(queryClient, id),
	});

	return {
		uploadCompletedBondForm: mutation.mutate,
		uploadCompletedBondFormIsLoading: mutation.isPending,
	};
};
